import e, { memo as pe, useCallback as ce, useMemo as ue } from "react";
import { useTheme as fe, useBreakpointValue as de, useDisclosure as xe, AspectRatio as ye, Image as Ee, Skeleton as he, Flex as h, Text as $, Link as Te } from "@chakra-ui/react";
import { ButtonLink as A } from "../../atoms/link/button-link.js";
import { getFocusIndicator as ke } from "../../../utils/accessibilityUtils.js";
import { typographyBreakpoints as He, getTypography as c, getResponsiveTypography as V } from "../../../utils/typographyUtils.js";
import { getRelAttributeAccordingToUrl as j } from "../../../utils/externalUrlChecker.js";
import { AnalyticsEventType as we } from "../../../types/analytics.enums.js";
import { isBrowser as ge } from "../../../utils/commonUtils.js";
import { Card as Be, CardMedia as _e, CardContent as De } from "../../atoms/card/card.js";
import { RichTextRenderer as Re } from "../../atoms/rich-text-renderer/rich-text-renderer.js";
import { InfoBadge as be } from "../../atoms/badge/info-badge/info-badge.js";
import { Modal as ze } from "../modal/modal.js";
import "react-icons/md";
import { Button as Ie } from "../../atoms/button/button.js";
import "../../atoms/button/icon-button.js";
import "react-icons/fa";
import "@loadable/component";
import "../../atoms/button/masthead-button.js";
import "framer-motion";
import "react-icons/fi";
import "react-icons/hi";
import "react-icons/ri";
import "react-icons/io5";
import "../../atoms/button/close-button.js";
const ve = (n) => typeof n == "object" ? /* @__PURE__ */ e.createElement(Re, { content: n }) : n, Fe = pe(
  ({
    variant: n,
    title: M,
    altText: U,
    cardCta1: t,
    cardCta2: o,
    cardCtaLink: m,
    cardCtaModal: l,
    cardImage: _,
    cardContent: P,
    cardBgColor: D,
    cardClickAction: T,
    chatbotWidget: r,
    launchChatbotAction: R,
    badge: k,
    cardMinWidth: H = "auto",
    noScroll: K = !1,
    position: q,
    trackingFn: b
  }) => {
    const i = fe(), {
      cardContentSpacing: w,
      cardContentPadding: u,
      action: { primaryHover: z, primaryDefault: I },
      linkUnderline: v,
      linkDefault: F,
      cardHorizontalImage: J,
      cardHorizontalImageShort: Q,
      element: { spacingMedium: X, spacingLarge: Y },
      cardHorizontalImageRadius: Z,
      button: { borderWidth: L },
      border: { actionSecondary: W }
    } = i, f = n === "short", g = ce(
      (s, p, E) => {
        s.preventDefault(), p && (b && b(we.UI_ENGAGEMENT, {
          actionType: "click",
          callToActionElement: p,
          position: q
        }), p != null && p.url && T && T(p.url), !f && (E != null && E.dataHandle) && R && R(E.dataHandle));
      },
      []
    ), B = ue(() => ({
      button: j(t == null ? void 0 : t.url),
      link: j(o == null ? void 0 : o.url)
    }), [t == null ? void 0 : t.url, o == null ? void 0 : o.url]), a = ke(D), C = de(He, {
      ssr: !ge(),
      fallback: "base"
    }), ee = {
      mobile: c("cardHeadlineMobile", i),
      tablet: c("cardHeadlineTablet", i),
      desktop: c("cardHeadlineDesktop", i)
    }, te = V(
      ee
    ), oe = {
      mobile: c("cardBodyMobile", i),
      tablet: c("cardBodyTablet", i),
      desktop: c("cardBodyDesktop", i)
    }, ne = V(
      oe
    ), { isOpen: re, onOpen: le, onClose: ie } = xe(), se = "auto", me = "fit-content", ae = "Mobile", d = H === se, x = H === me, y = d || x, S = d && C === ae, G = S ? "row" : y ? "column" : "row", N = f ? Q : J, O = `${L} solid ${W}`;
    return /* @__PURE__ */ e.createElement(
      Be,
      {
        variant: "horizontal",
        width: "inherit",
        overflow: "hidden",
        minW: K ? "fit-content" : H,
        height: "100%",
        background: D
      },
      _ && /* @__PURE__ */ e.createElement(
        _e,
        {
          sx: {
            height: N,
            width: N,
            justifyContent: "center",
            marginLeft: u,
            my: u
          },
          flex: "0"
        },
        /* @__PURE__ */ e.createElement(ye, { ratio: 1 / 1, width: "inherit", overflow: "hidden" }, /* @__PURE__ */ e.createElement(
          Ee,
          {
            fallback: /* @__PURE__ */ e.createElement(he, { "data-testid": "skeleton-image", w: "100%", minH: "100%" }),
            "data-testid": `${n}-feature-card-image`,
            src: _,
            alt: U || "",
            loading: "lazy",
            height: "inherit",
            borderRadius: Z
          }
        ))
      ),
      /* @__PURE__ */ e.createElement(De, { p: u, flex: "1" }, /* @__PURE__ */ e.createElement(
        h,
        {
          direction: d ? "row" : "column",
          h: "100%",
          justifyContent: "space-between",
          columnGap: y ? w : "",
          rowGap: w,
          flexFlow: S || x ? "column" : "",
          flexWrap: "wrap"
        },
        /* @__PURE__ */ e.createElement(
          h,
          {
            direction: "column",
            rowGap: w,
            justifyContent: d ? "center" : "flex-start",
            flex: "1"
          },
          k && /* @__PURE__ */ e.createElement(h, null, /* @__PURE__ */ e.createElement(be, { badgeClass: k.badgeClass }, k.text)),
          /* @__PURE__ */ e.createElement(
            $,
            {
              "data-testid": `${n}-feature-card-title`,
              noOfLines: 2,
              as: "h3",
              ...te
            },
            ve(M)
          ),
          /* @__PURE__ */ e.createElement(
            $,
            {
              "data-testid": `${n}-feature-card-content`,
              ...ne
            },
            P
          )
        ),
        /* @__PURE__ */ e.createElement(
          h,
          {
            direction: G,
            alignItems: "center",
            rowGap: X,
            columnGap: Y,
            justifyContent: G === "row" ? "flex-start" : "center",
            flex: y ? "0.5" : "",
            paddingRight: y ? u : "",
            flexWrap: "wrap"
          },
          t && /* @__PURE__ */ e.createElement(
            A,
            {
              ...(r == null ? void 0 : r.dataHandle) && {
                "data-handle": r.dataHandle
              },
              "data-testid": `${n}-feature-card-cta`,
              _hover: { textDecoration: "none" },
              href: t == null ? void 0 : t.url,
              onClick: (s) => g(s, t, r),
              rel: B.button,
              _focus: a,
              variant: "secondary",
              size: "medium",
              _focusVisible: a,
              border: O,
              sx: { textAlign: x && "center" }
            },
            t.text
          ),
          !f && o && /* @__PURE__ */ e.createElement(
            A,
            {
              ...(r == null ? void 0 : r.dataHandle) && {
                "data-handle": r.dataHandle
              },
              "data-testid": "horizontal-feature-card-cta2",
              _hover: { textDecoration: "none" },
              href: o == null ? void 0 : o.url,
              onClick: (s) => g(s, o, r),
              rel: B.button,
              _focus: a,
              variant: "secondary",
              size: "medium",
              _focusVisible: a,
              border: O,
              sx: { textAlign: x && "center" }
            },
            o.text
          ),
          (m == null ? void 0 : m.url) && /* @__PURE__ */ e.createElement(
            Te,
            {
              "data-testid": `${n}-feature-card-cta-link`,
              _hover: {
                textDecoration: "none",
                color: z
              },
              href: m.url,
              onClick: (s) => g(s, m),
              rel: B.link,
              textDecoration: v,
              flexShrink: "0",
              color: I,
              ...F
            },
            m.text
          ),
          !f && l && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
            Ie,
            {
              className: "cta-link",
              "data-testid": "horizontal-feature-card-cta-modal",
              _hover: {
                textDecoration: "none",
                color: z
              },
              _focus: a,
              onClick: le,
              _focusVisible: a,
              textDecoration: v,
              flexShrink: "0",
              p: "0",
              color: I,
              backgroundColor: "transparent",
              ...F
            },
            l.linkText
          ), /* @__PURE__ */ e.createElement(
            ze,
            {
              contentTitle: l.contentTitle,
              modalTitle: l.modalTitle,
              modalSupertext: l.modalSupertext,
              contentText: l.contentText,
              callToAction1: {
                text: l.callToAction1.text
              },
              callToAction2: {
                text: l.callToAction2.text,
                url: l.callToAction2.url
              },
              ctaClickHandler: T,
              isOpen: re,
              onClose: ie,
              isFooterCentered: !0
            }
          ))
        )
      ))
    );
  }
);
Fe.displayName = "HorizontalFeatureCard";
export {
  Fe as HorizontalFeatureCard
};
